'use strict';

// @flow

var FirebaseRooms = function FirebaseRooms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { metadata: {}, members: {}, messages: {} };
  var action = arguments[1];

  switch (action.type) {
    case 'FIREBASE_ROOMS_UPDATE_VALUE':
      {
        var newState = Object.assign({}, state);
        newState[action.label] = Object.assign({}, state[action.label]);
        newState[action.label][action.id] = {
          loading: false,
          value: action.value ? action.value : {}
        };
        return newState;
      }

    default:
      return state;
  }
};

module.exports = FirebaseRooms;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/reducers/FirebaseRooms.js
// module id = 1022
// module chunks = 0